export default __webpack_public_path__ + "static/media/webTopHover.4934701e.png";